import { Id_attachment, Id_location } from "./api/Identifiers";
import { Attachment, AttachmentCollection } from "./Attachment";
import { cms_logging } from "./cms_logging";
import { Point } from "./Point";
import { Rectangle } from "./Rectangle";


export function parse_attachment(raw_attachment: any): Attachment {
    // check for required values
    if (!raw_attachment.id) {
        cms_logging.api_error("missing 'id'", "", "getattachmentsbylocation", raw_attachment);
        return null;
    }
    let fail = false;

    ["xCoord", "yCoord", "p1xCoord", "p1yCoord", "p2xCoord", "p2yCoord", "url", "idLocation"].forEach(key => {
        if (!raw_attachment[key]) {
            cms_logging.api_error(`missing '${key}'`, `${raw_attachment.id}`, "getattachmentsbylocation", raw_attachment);
            fail = true;
        }
    });
    if (fail) {
        return null;
    }
    return new Attachment(
        Id_attachment.wrap(raw_attachment.id),
        raw_attachment.url,
        Point.build(raw_attachment.xCoord,
            raw_attachment.yCoord),
        Rectangle.build(Point.build(raw_attachment.p1xCoord,
            raw_attachment.p1yCoord),
        Point.build(raw_attachment.p2xCoord,
            raw_attachment.p2yCoord)),
        raw_attachment.location,
        Id_location.wrap(raw_attachment.idLocation),
        raw_attachment,
        raw_attachment.description
    );
}

export function  parse_attachments(raw_attachments: any[]): AttachmentCollection {
    let r: AttachmentCollection = new AttachmentCollection();
    raw_attachments.forEach(element => {
        let a: Attachment = parse_attachment(element);
        if (a) {
            r.update(a);
        }
    });
    return r;
}
